@if (visible) {
<ion-button
  expand="block"
  class="load-more-btn"
  [disabled]="disabled"
  (click)="clicked.emit()"
>
  @if (loading) {
  <ion-spinner slot="start" name="crescent" class="mr-2 w-4 h-4"></ion-spinner>
  }
  {{
    loading
      ? ("loading-button.loading" | translate)
      : ("loading-button.loadMore" | translate)
  }}
</ion-button>
}
